<template>

   <div class="main-content-container  container-fluid">

        <div class="page-header row no-gutters py-4  mb-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{$t("REPORTS.LAST_DATA")}}</span>
            </div>
        </div>

        <w-card size="100">
            <div class="row mb-2">
                <div class="col-12 col-lg-6 text-lg-left text-center ">
                    <el-select v-model="selectedSiteId" v-loading="loadingSites" class="mb-2 mb-lg-0">
                        <el-option
                                v-for="item in sites"
                                :key="item.id"
                                :label="item.nombre"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
               <!-- <div class="col-12 col-lg-6 text-lg-right text-center">
                    <el-date-picker
                            v-model="date"
                            type="date"
                            :placeholder="$t('REPORTS.PICK_A_DATE')"
                            align="center"
                    >
                    </el-date-picker>
                </div>
               -->
               <div class="col-12 col-lg-6 text-lg-right text-center">
                   <p class="mb-2 mb-lg-0">{{$t("REPORTS.STATUS_COLOR")}} </p>
                   <el-switch
                     v-model="siloColor" >
                   </el-switch>
               </div>

            </div>
            <hr>
            <el-row style="height: 100px" v-if="loadingSilos" v-loading="loadingSilos"/>
            <h5 v-if="!userHasSites" class="text-center text-invalid">{{$t('HISTORICS.NO_SITES') }}</h5>
            <div class="row" v-if="!loadingSilos && silos.length > 0 ">
                <div class="col-12  mb-4" v-for="silo in silos" v-bind:key="silo.id">
                    <div class="d-flex align-items-center">
                        <h5>{{silo.nombre}}</h5>
                        <h6 class="text-muted ml-2 text-capitalize">({{$t('GRAIN.' + silo.type.toUpperCase()) }})</h6>
                    </div>
                     <div class="d-flex align-items-center">
                    
                        <h6> {{$t("REPORTS.BAGGED_DATE")}} 
                            <span v-if="silo.baggedate === '1999-12-31 23:59:59'"> - </span> 
                            <span v-else class = "font-weight-bold">{{formatDate(silo.baggedate)}}  </span> 
                            | 
                            {{$t("REPORTS.INI_MOISTURE")}}
                            <span v-if="silo.initmoisture === '0'"> - </span> 
                            <span v-else class = "font-weight-bold">{{silo.initmoisture}}%</span> 
                            | 
                            {{$t("REPORTS.TONS")}}
                            <span v-if="silo.tons === '0'"> - </span>   
                            <span v-else class = "font-weight-bold">{{silo.tons}}</span>
                        </h6>                    
                    </div>

                    <div v-if = siloEntire >
                        <entireSiloImg :id="silo.id" :siteId="selectedSiteId"
                             :date="new Date(date)" :silo-name="silo.nombre" :siloColor="siloColor" 
                             :siteName="siteName" :siloType="silo.type" />
                    </div>
                    <div v-else>
                        <siloImg :id="silo.id" :siteId="selectedSiteId"
                             :date="new Date(date)" :silo-name="silo.nombre" :siloColor="siloColor"  />
                    </div>
                    
                </div>

            </div>
        </w-card>
    </div>

</template>

<script>
    import wCard from "../components/common/wCard";
    import SiloMetricsChart from "../components/common/charts/SiloMetricsChart"
    import api from "../utils/api/api.js"
    import siloImg from "../components/common/siloImg";
    import entireSiloImg from "../components/common/entireSiloImg";
    import dateFormater from "../utils/dateFormater";


    export default {
        name: "report",
        components: {
            "w-card": wCard,
            "silo-metrics-chart": SiloMetricsChart,
            "siloImg": siloImg,
            "entireSiloImg": entireSiloImg
        },
        data: function () {
            return {
                date: (new Date()).toDateString(),
                sites: [],
                selectedSiteId: undefined,
                silos: [],
                sections: [],
                loadingSilos: undefined,
                userHasSites: true,
                siloColor: true,
                siloEntire: true,
                siteName: undefined
            }
        },
        computed: {
            loadingSites: function () {
                return this.sites.length === 0 && this.userHasSites;
            },
        },
        methods: {
            formatDate(date) {
                return dateFormater.onlyDateFormat(date,this.$store.state.language);
            },
            getSiteName(id)
            {
                let i;
                for(i=0;i<this.sites.length;i++)
                {
                    if(this.sites[i].id === id)
                    {
                        this.siteName = this.sites[i].nombre;
                    }
                }
            }
        },
        watch: {
            selectedSiteId: function () {
                if (this.selectedSiteId === undefined) {
                    this.silos = [];
                }
                
                this.getSiteName(this.selectedSiteId);

                this.loadingSilos = true;
                api.getSilos(this.selectedSiteId).then(value => {
                    this.silos = value.silos;
                    this.silos.sort((a, b) => {
                        return b.cant_sens - a.cant_sens
                    });
                    this.loadingSilos = false;
                });
            },
            siloColor: function()
            {
                /*if(this.siloColor)
                {
                    this.siloColor = false;
                }
                else
                {
                    this.siloColor = true;
                }
                */
            },
            date(newDate) {
                console.info("Nueva fecha ", newDate);
            }
        },
        mounted() {
            api.getSites().then(value => {
                this.sites = value.sites;
                if (this.sites.length > 0 && this.sites[0].id !== undefined) {
                    this.selectedSiteId = this.sites[0].id;
                }
            }).catch(reason => {
                if (reason.code === 17) {
                    this.userHasSites = false;
                }
            });


        }

    }
</script>

<style>

</style>